export function bodyLock() {
    document.querySelector('body').classList.add('lock');
}

export function bodyOpen() {
    document.querySelector('body').classList.remove('lock');
}
